import React, { useState, useEffect, useCallback } from "react";
import SwipeableViews from "react-swipeable-views";
import {
  Typography,
  AppBar,
  Toolbar,
  Link,
  CardActionArea,
  TextField,
  Button,
  Paper,
  FormControlLabel,
  Checkbox,
  Tabs,
  Tab,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  Switch,
  Divider,
  ButtonGroup,
  useMediaQuery,
  Menu,
  Box,
  MenuItem,
} from "@material-ui/core";
import {
  Grid,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  LinearProgress,
  CircularProgress,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
  Popover,
  Chip,
} from "@material-ui/core";
import {
  DesktopMac,
  Add,
  Block,
  DonutSmall,
  VerifiedUser,
  FilterList,
  Equalizer,
  DonutLarge,
  Assignment,
  Close,
  MoreVert,
  ArrowForwardIos,
} from "@material-ui/icons";

import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";

import { useSnackbar } from "notistack";

import { withLocalize, Translate } from "react-localize-redux";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";

import Settlements from "./finance/settlements";
import { AccountTransactions } from "./finance/transactions";
import { ServiceFeeTransaction } from "./finance/service_fee_transactions";
import { ReversedServiceFeeTransactions } from "./finance/reversed_service_fee_transactions";

import { makeStyles, useTheme } from "@material-ui/styles";
import { PaymentRequestTransactions } from "./finance/payment_requests.jsx";
import { FloatReports } from "./finance/float_report.jsx";
import FinancialSettlements from "./finance/financial_settlements.jsx";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.up("sm")]: {
      marginLeft: 250,
    },
  },
  holder: {
    [theme.breakpoints.up("sm")]: {
      marginLeft: -250,
    },
  },
  tabs: {
    marginTop: -theme.spacing(3),
    marginLeft: -16,
  },
  title: {
    flexGrow: 1,
  },
  btn: {
    textTransform: "capitalize",
  },
  btn2: {
    textTransform: "capitalize",
    border: "dashed grey 1px",
  },
  paper: {
    padding: 15,
  },
  action: {
    borderRadius: 15,
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function Finance(props) {
  const classes = useStyles();
  const history = useHistory();

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("sm"));
  const [menuOpen, setMenuOpen] = useState(null);

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [accountData, setAccountData] = useState({});

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <div className={classes.root}>
        {/* Dialogs ends here */}
        <Box display="flex" alignItems="center">
          <Box mr={2}>
            {" "}
            <Equalizer color="primary" fontSize="large" />
          </Box>
          <Box flexGrow={1} display="flex" alignItems="center">
            <Typography variant="h5">
              <b>Reports</b>
            </Typography>
            <Box ml={1} mr={1} mt={1}>
              <ArrowForwardIos fontSize="small" />
            </Box>
            <Typography variant="h6">Finance</Typography>
          </Box>
        </Box>
        {/* ////////// */}
        <Box width={1} style={{ marginLeft: -16 }}>
          <Paper square elevation={0} style={{ marginRight: -30 }}>
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              aria-label="Tabs"
              scrollButtons="on"
              variant="scrollable"
            >
              <Tab label="Transactions" />
              <Tab label="Transport Settlements" />
              <Tab label="FInancial Settlements" />
              <Tab label="Service Fee Transactions" />
              <Tab label="Reversed Service Fee " />
              <Tab label="Float Report" />
              {/* <Tab label="Routes" disabled />
            <Tab label="Stops" disabled />
            <Tab label="Schedules" disabled />
            <Tab label="Vehicles" />
            <Tab label="Drivers" />
            <Tab label="Tickets" disabled />

            <Tab label="Settings" /> */}
            </Tabs>
          </Paper>
        </Box>
        <Box mt={3} className={classes.holder}>
          <SwipeableViews
            axis={theme.direction === "rtl" ? "x-reverse" : "x"}
            index={value}
            onChangeIndex={handleChangeIndex}
          >
            <TabPanel value={value} index={0} dir={theme.direction}>
              <AccountTransactions />
            </TabPanel>
            <TabPanel value={value} index={1} dir={theme.direction}>
              <Settlements />
            </TabPanel>

            <TabPanel value={value} index={2} dir={theme.direction}>
              <FinancialSettlements />
            </TabPanel>

            <TabPanel value={value} index={3} dir={theme.direction}>
              <ServiceFeeTransaction />
            </TabPanel>
            <TabPanel value={value} index={4} dir={theme.direction}>
              <ReversedServiceFeeTransactions />
            </TabPanel>
            <TabPanel value={value} index={5} dir={theme.direction}>
              <FloatReports />
            </TabPanel>

            {/* <TabPanel value={value} index={2} dir={theme.direction}>
            <PaymentRequestTransactions/>
          </TabPanel> */}
          </SwipeableViews>
        </Box>
      </div>
    </MuiPickersUtilsProvider>
  );
}

const FinanceReport = withLocalize(Finance);
export { FinanceReport };
